/* Position + animate the header mega-menu dropdowns.

   Positioning: the panel drops below the whole (possibly two-row) nav via CSS
   (top:100%); align() sets its left so it lines up under the trigger you opened —
   or, when the panel is too wide to sit there, centers it on the trigger so a wide
   menu like "Other TCG" reads as a balanced, centered block.

   Close: a native <details> stops painting its content the instant it closes, so we
   fade the panel out first, then actually close it.

   Everything is wired with document-level *capture* delegation rather than
   per-element listeners, so it keeps working no matter when the header section
   renders or re-renders (the earlier per-element version silently missed the live
   elements). Note: the <details> 'toggle' event does not bubble, but capture-phase
   listeners on the document still receive it on the way down to the target. */
(function () {
  var GUTTER = 16;
  var MENU_SEL = '.header__inline-menu details.mega-menu';

  function align(details) {
    var content = details.querySelector('.mega-menu__content');
    var summary = details.querySelector('summary');
    var nav = details.closest('.header__inline-menu');
    if (!content || !summary || !nav) return;
    // clientWidth excludes the scrollbar — innerWidth let wide panels sit ~15px
    // under it (same off-by-a-scrollbar the cart positioning already fixed)
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var navRect = nav.getBoundingClientRect();
    var sumRect = summary.getBoundingClientRect();
    var width = content.getBoundingClientRect().width || content.offsetWidth || 400;
    // First choice: line the panel's left edge up under the trigger.
    var left = sumRect.left - navRect.left;
    // If the panel is too wide to sit under the trigger (it would run off the right
    // edge), don't jam it against the edge — center it on the trigger instead.
    if (navRect.left + left + width > vw - GUTTER) {
      var abs = sumRect.left + sumRect.width / 2 - width / 2; // center on the trigger
      abs = Math.max(GUTTER, Math.min(abs, vw - GUTTER - width)); // keep on screen
      left = abs - navRect.left;
    }
    if (navRect.left + left < GUTTER) left = GUTTER - navRect.left;
    // use !important so it beats the CSS `left: 0 !important` fallback
    content.style.setProperty('left', left + 'px', 'important');
    // Connect the panel to ITS bubble: drop it just below the trigger's own row
    // instead of below the whole (possibly two-row) nav — a first-row menu no longer
    // floats a full row away from its bubble. The panel simply overlays the second
    // row (CSS gives it the z-index).
    var top = sumRect.bottom - navRect.top + 2;
    content.style.setProperty('top', top + 'px', 'important');
  }

  function scheduleAlign(details) {
    // two frames so the panel has laid out its columns, plus a late backup for
    // wide panels whose width settles a beat after opening
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { align(details); });
    });
    setTimeout(function () { if (details.open) align(details); }, 90);
  }

  function closestMenu(node) {
    return node && node.closest ? node.closest(MENU_SEL) : null;
  }

  // Open: the <details> fires a (non-bubbling) 'toggle' — catch it in the capture
  // phase at the document so it fires regardless of header render timing.
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches(MENU_SEL) && d.open) scheduleAlign(d);
  }, true);

  // Shared fade-then-close: fade the panel out first, then actually close it.
  // Also flips aria-expanded immediately — the fade delay was leaving the summary
  // announcing "expanded" for 300ms after every click-close (stale ARIA).
  function fadeClose(d) {
    if (d.dataset.closing || !d.open) return;
    d.dataset.closing = '1';
    var summary = d.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    var content = d.querySelector('.mega-menu__content');
    if (content) content.classList.add('is-closing');
    setTimeout(function () {
      if (content) content.classList.remove('is-closing');
      d.open = false;
      delete d.dataset.closing;
      // Dawn's HeaderMenu sets header.preventHide from ITS toggle — this deferred
      // close would clobber it to false while ANOTHER menu is still open, letting
      // the sticky header hide over an open panel. Recompute from reality after
      // the toggle task has run.
      setTimeout(function () {
        var hw = document.querySelector('.header-wrapper');
        if (hw) hw.preventHide = !!document.querySelector(MENU_SEL + '[open]:not([data-closing])');
      }, 0);
    }, 300);
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest ? e.target.closest(MENU_SEL + ' > summary') : null;
    if (!summary) return;
    var d = summary.parentElement;
    if (d.dataset.closing) {
      // a close animation is mid-flight — swallow further clicks so the native
      // <details> can't snap shut without the fade
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    if (d.open) {
      e.preventDefault();
      e.stopImmediatePropagation();
      fadeClose(d);
    }
  }, true);

  // Outside click/tap closes any open menu. Dawn only closes on focusout, which
  // Safari/Firefox don't fire for background clicks (they don't focus the summary),
  // so the menu stayed open when clicking the page or opening the cart over it.
  // pointerup covers iOS taps on non-clickable areas; mouse-only closes via click
  // so a text-selection drag released outside doesn't dismiss it.
  function closeOnOutside(e) {
    if (e.type === 'pointerup' && e.pointerType === 'mouse') return;
    Array.prototype.forEach.call(document.querySelectorAll(MENU_SEL + '[open]'), function (d) {
      if (d.contains(e.target)) return; // interaction inside this menu — leave it
      fadeClose(d); // also closes menu A when the user opens menu B in Safari
    });
  }
  document.addEventListener('click', closeOnOutside);
  document.addEventListener('pointerup', closeOnOutside);

  window.addEventListener('resize', function () {
    Array.prototype.forEach.call(document.querySelectorAll(MENU_SEL + '[open]'), align);
  });

  // Align any menu already open at load.
  function initialAlign() {
    Array.prototype.forEach.call(document.querySelectorAll(MENU_SEL + '[open]'), scheduleAlign);
  }
  if (document.readyState !== 'loading') initialAlign();
  else document.addEventListener('DOMContentLoaded', initialAlign);
})();

/* Nav dividers: the CSS draws a hairline BEFORE each item in the header nav and the
   footer Shop links, but only on items marked .nav-divide — items that CONTINUE a
   visual row. Both lists wrap responsively, so without this the first item of a
   wrapped row would start with a stray floating divider. Fail-safe by design: if
   this never runs, there are simply no dividers (never a wrong one). */
(function () {
  var LISTS = [
    // empty: header AND footer links are bubbles now (no dividers anywhere), so
    // there is nothing left to mark — kept as a hook in case dividers return
  ];
  function markList(ul) {
    var prevTop = null;
    Array.prototype.forEach.call(ul.children, function (li) {
      var top = li.getBoundingClientRect().top;
      // divider only when this item sits on the same row as the previous one.
      // Tolerance, not equality: sub-pixel layout can put same-row items ~1px
      // apart (seen live in the footer), while a real row jump is 40px+.
      li.classList.toggle('nav-divide', prevTop !== null && Math.abs(top - prevTop) < 10);
      prevTop = top;
    });
  }
  function markRows() {
    LISTS.forEach(function (sel) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), markList);
    });
  }
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(markRows, 80);
  });
  // fonts can reflow the nav (and change where rows wrap) after DOMContentLoaded
  if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
    document.fonts.ready.then(markRows).catch(function () {});
  }
  if (document.readyState !== 'loading') markRows();
  else document.addEventListener('DOMContentLoaded', markRows);
})();
